export default __webpack_public_path__ + "static/media/myTeamRecruiter.6cf53fca.png";